import axios from '@/libs/api.request'



var comment={
    
}

comment.add = (r) => {
    return axios.request({
      url: 'api/Comment/Add',
      data:r,
      method: 'post'
    })
  }
 
  comment.list = (query) => {
    return axios.request({
      url: 'api/Comment/List',
      params:query,
      method: 'get'
    })
  }


  comment.delete = (r) => {
    return axios.request({
      url: 'api/Comment/Delete',
      data:r,
      method: 'post'
    })
  }

 

export default comment;